<template>
  <div class="content-box" :class="{'pl-norange':isCollapse}">
    <menuSide style="overflow:hidden;" :isCollapse="isCollapse"></menuSide>

    <el-container>
      <el-header class="header-box" :class="{'pl-norange-header':isCollapse}" style="text-align: right; font-size: 12px">
        <HeaderBar @reload="reload" @ShowNav="ShowNav"></HeaderBar>
      </el-header>
      <el-main class="main">
        <router-view ref="appmain" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import HeaderBar from '../components/HeaderBar.vue'
import menuSide from '../components/menuSide.vue'
export default {
  components: {
    HeaderBar,
    menuSide
  },
  data() {
    return {
      isCollapse: false
    }
  },
  mounted() {},
  created() {},
  methods: {
    reload() {
      if (this.$refs.appmain.reload) {
        this.$refs.appmain.reload()
      }
    },
    ShowNav() {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style>
.content-box {
  padding-left: 200px;
  height: 100%;
  overflow-y: auto;
}
.content-box.pl-norange {
  padding-left: 80px;
}
.el-aside {
  overflow: visible;
}
.main {
  padding: 70px 40px 20px !important;
  background: #f0f4fb;
}
.header-box {
  position: fixed;
  left: 200px;
  top: 0;
  right: 0;
  padding: 15px 30px;
  background-color: #fff;
  color: #333;
  z-index: 999;
  border-bottom: 1px solid #eaeaea;
}
.header-box.pl-norange-header {
  left: 65px;
}
</style>



// WEBPACK FOOTER //
// src/layout/Layout.vue